export type WaitlistTimePreference =
  | 'morning'
  | 'afternoon'
  | 'evening'
  | 'afterHours';

export const TIME_PREFERENCE_ORDER: readonly WaitlistTimePreference[] = [
  'morning',
  'afternoon',
  'evening',
  'afterHours',
];

export const getOfferedTimePreferences = (
  showAfterHours: boolean,
): WaitlistTimePreference[] =>
  TIME_PREFERENCE_ORDER.filter(
    (preference) => showAfterHours || preference !== 'afterHours',
  );

// An empty list means Anytime; selecting every shown row collapses back to it.
export const normalizeTimePreferences = (
  current: WaitlistTimePreference[],
  offered: WaitlistTimePreference[],
): WaitlistTimePreference[] => {
  const kept = TIME_PREFERENCE_ORDER.filter(
    (preference) =>
      current.includes(preference) && offered.includes(preference),
  );
  return kept.length === offered.length ? [] : kept;
};

export const toggleTimePreference = (
  current: WaitlistTimePreference[],
  preference: WaitlistTimePreference,
  offered: WaitlistTimePreference[],
): WaitlistTimePreference[] =>
  normalizeTimePreferences(
    current.includes(preference)
      ? current.filter((selected) => selected !== preference)
      : [...current, preference],
    offered,
  );

export const formatWaitlistTimePreferences = (
  preferences: WaitlistTimePreference[],
  label: (key: WaitlistTimePreference | 'anytime') => string,
): string =>
  preferences.length === 0
    ? label('anytime')
    : TIME_PREFERENCE_ORDER.filter((preference) =>
        preferences.includes(preference),
      )
        .map(label)
        .join(', ');

export const toTrackedTimePreferences = (
  preferences: WaitlistTimePreference[],
): string =>
  preferences.length === 0
    ? 'anytime'
    : TIME_PREFERENCE_ORDER.filter((preference) =>
        preferences.includes(preference),
      ).join(',');
